import type { ComponentStyleConfig } from "@chakra-ui/react";

export const ModalTheme: ComponentStyleConfig = {
  baseStyle: {
    dialog: {
      borderRadius: 0,
      width: "100%",
    },
    header: {
      fontSize: "xl",
    },
    closeButton: {
      bg: "brand.gray.90",
      height: "3rem",
      width: "3rem",
      top: 3,
      borderRadius: "1000px",
    },
  },
  sizes: {
    half: {
      dialog: {
        maxWidth: "50vw",
        borderRadius: 8,
      },
    },
    "6xl": {
      dialog: {
        maxWidth: "calc(100vw - 8rem)",
      },
    },
  },
};
